import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Progress,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  Colxx,
  Separator,
} from "../../../../../components/common/CustomBootstrap";
import ReactStars from "react-rating-stars-component";
import { Link, NavLink } from "react-router-dom";
import classnames from "classnames";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import Linkify from "react-linkify";
import { JobService } from "../../../../../services/JobService";
import { FiStar } from "react-icons/fi";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { getEnumLists } from "../../../../../services/MetadataService";
import { ENV, isNullOrEmpty } from "../../../../../config/ENV";
import { GoMail } from "react-icons/go";
import { MdOutlinePhoneIphone } from "react-icons/md";
import { GrLocation } from "react-icons/gr";
import { CgDollar, CgWindows } from "react-icons/cg";
import { IoCalendarNumberOutline } from "react-icons/io5";
import Accordion from "react-bootstrap/Accordion";
import ReactToPrint from "react-to-print";
import { getDateDifference } from "../../../../../utilities/durationutility";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { formattedMobileNumber } from "../../../../../utilities/phonenumberutility";
import squarebullet from "../../../../../../src/assets/img/smartresumeimgs/Bullet-Square.png";
import sortArray from "sort-array";
import { showLocalDateTime } from "../../../../../utilities/timeutility";
import { Mention, MentionsInput } from "react-mentions";
import mentionsInputStyles from "../../../../../assets/css/mentionsInputStyles";
import mentionStyle from "../../../../../assets/css/mentionStyle";
const ViewCandidateDetails = (props) => {
  const history = useHistory();
  const [basicInfo, setBasicInfo] = useState({});
  const [experienceList, setExperienceList] = useState([]);
  const [educationList, setEducationList] = useState([]);
  const [files, setFiles] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [softSkills, setSoftSkills] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [jobpref, setJobPrep] = useState({});
  const [highlights, sethighlights] = useState([]);
  const [jobStatus, setJobStatus] = useState("");
  const [jobType, setJobType] = useState("");
  const [empTerm, setEmpTerm] = useState("");
  const [jobShift, setJobShift] = useState("");
  const [activeTab, setActiveTab] = useState("jobRelated");
  const [shortlisted, setShortlisted] = useState(false);
  const [jobRequestId, setJobRequestId] = useState("");
  const [jobTenure, setJobTenure] = useState(false);
  const [salaryExpectations, setSalaryExpectations] = useState(false);
  const [insuffOrIrrelevantExp, setInsuffOrIrrelevantExp] = useState(false);
  const [insuffOrIrrelevantEdu, setInsuffOrIrrelevantEdu] = useState(false);
  const [missingLicencesOrCerts, setMissingLicencesOrCerts] = useState(false);
  const [selectedAnotherCandidate, setSelectedAnotherCandidate] =
    useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [prevRejectedCandidate, setPrevRejectedCandidate] = useState(false);
  const [poorInterview, setPoorInterview] = useState(false);
  const [hiringOfferDeclined, setHiringOfferDeclined] = useState(false);
  const [noShow, setNoShow] = useState(false);
  const [relevantJobExp, setRelevantJobExp] = useState(false);
  const [relevantEdu, setRelevantEdu] = useState(false);
  const [strongSkillFit, setStrongSkillFit] = useState(false);
  const [relevantLanguages, setRelevantLanguages] = useState(false);
  const [grtSoftSkillFit, setGrtSoftSkillFit] = useState(false);
  const [interviewType, setInterviewType] = useState("IN_PERSON");
  const [notesAdded, setNotesAdded] = useState("");
  const [jobInterviewTypes, setJobInterviewTypes] = useState([]);
  const [askCandidateQuestions, setAskCandidateQuestions] = useState(false);
  const [adlReasons, setAdlReasons] = useState("");
  const [additionalReasons, setAdditionalReasons] = useState("");
  const [jobSkills, setJobSkills] = useState([]);
  const [status, setStatus] = useState("");
  const [statusValue, setStatusvalue] = useState("");
  const [location, setLocation] = useState({});
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [showShortlisted, setShowShortlisted] = useState(false);
  const [clientComment, setClientComment] = useState("");
  const [clientQuestion, setClientQuestion] = useState("");
  const [clientAcceptanceNotes, setClientAcceptanceNotes] = useState("");
  const [clientRejectReason, setClientRejectReason] = useState("");
  const [jobReqStatus, setJobReqStatus] = useState("");
  const [skillFit, setSkillFit] = useState(80);
  const [checked, setChecked] = useState(false);
  const [jobPrefScore, setjobPrefScore] = useState(0);
  const [skillFitScore, setskillFitScore] = useState(0);
  const [peerRatingScore, setjobfitScore] = useState(0);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [jobId, setJobId] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [credibilityReason, setCredibilityReason] = useState("");
  const [jobApplicantTypes, setJobApplicantTypes] = useState([]);
  const [applicantStatus, setApplicantStatus] = useState("");
  const [interviewScheduled, setInterviewScheduled] = useState(false);
  const [interviewRequested, setInterviewRequested] = useState(false);
  const [interviewCompleted, setInterviewCompleted] = useState(false);
  const [taActionRequired, setTaActionRequired] = useState(false);
  const [show, setShow] = useState(true);
  const [Tareject, SetTareject] = useState(false);
  const [taNotes, setTaNotes] = useState([]);
  const [notes, setNotes] = useState("");
  const [modalcopy, setModalcopy] = useState(false);
  const [noteId, setNoteId] = useState();
  const [selectedNoteId, setSelectedNoteId] = useState("");
  const userId = window.localStorage.getItem("user");
  const componentRef = useRef();
  const count = 0;
  const [appliedDays, setAppliedDays] = useState(0);
  const [modifiedDays, setModifiedDays] = useState(0);
  const [applieddOn, setApplieddOn] = useState(0);
  const [modifiedOn, setModifiedOn] = useState(0);
  const [modalBasic, setModalBasic] = useState(false);
  const [taSelectedNotes, setTaSelectedNotes] = useState("");
  const [selectedMentions, setSelectedMentions] = useState([]);
  const [users, setUsers] = useState([]);
  const [userMentions, setUserMentions] = useState([]);
  const [notesHistory, setNotesHistory] = useState([]);
  const { searchId, jobreqid, applicationid, candidateid } = useParams();
  const applicationId = applicationid;
  // const candidateId = candidateid;
  const [candidateId, setCandidateId] = useState("");

  useEffect(() => {
    getJobEnums();
    getTalentAdvisors();
    if (applicationId !== "") {
      getCandidateReviewDetails(applicationId);
      getTaNotes(applicationId);
      getcandidateNotesHistory(applicationId);
    }
  }, [count]);
  const getTaNotes = () => {
    JobService.getTaNotes(applicationId, jobreqid).then((response) => {
      if (response.data !== null) {
        setTaNotes(response.data.notes);
      }
    });
  };

  const getTalentAdvisors = () => {
    JobService.getActiveTAService().then((response) => {
      try {
        if (response.data !== null) {
          setUsers(response.data.members);
          let arr = [];
          for (let i = 0; i < response.data.members.length; i++) {
            let obj = {
              id: response.data.members[i].id,
              display: response.data.members[i].displayName,
            };

            arr.push(obj);
          }
          setUserMentions(arr);
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err.message));
      }
    });
  };

  const getJobEnums = () => {
    getEnumLists().then((response) => {
      if (response !== null) {
        let jobApplicantTypes = response.jobApplicantTypes;
        if (jobApplicantTypes != null) {
          setJobApplicantTypes(jobApplicantTypes);
        }
        let jobInterviewTypes = response.jobInterviewTypes;
        if (jobInterviewTypes != null) {
          setJobInterviewTypes(jobInterviewTypes);
        }
      }
    });
  };

  const count1 = 0;
  useEffect(() => {
    getShortlistedReasons();
    getRejectedReasons();
  }, [count1]);
  const getCandidateReviewDetails = () => {
    JobService.getCandidateDetails(applicationId, jobreqid, searchId).then(
      (response) => {
        if (response.data == null) {
          return;
        }
        const candidateReviewDetails = response.data;
        var candidate = candidateReviewDetails.candidate;
        var basicInfo = candidate.basicInfo;
        setCandidateId(candidate.basicInfo.candidateId);
        var address = basicInfo.address;
        var job = candidateReviewDetails.job;
        var jobApplication = candidateReviewDetails.jobApplication;
        var candidateSkills = candidate.skills.skills;
        var onjobSkills = job.skills.skills;
        var candidateJobpref = candidate.jobPref;
        setJobId(candidateReviewDetails.job.jobDetails.jobId);
        setJobTitle(candidateReviewDetails.job.jobDetails.jobTitle);
        setJobRequestId(candidateReviewDetails.job.jobDetails.id);

        setCredibilityReason(candidate.credible_ratings_reasons);
        setBasicInfo(basicInfo);
        setLocation(address);

        if (jobApplication != null) {
          setjobfitScore(jobApplication.peerRatingScore);
          setjobPrefScore(jobApplication.jobPrefScore);
          setskillFitScore(jobApplication.skillFitScore);

          if (jobApplication.applicantStatus !== null) {
            setStatus(jobApplication.applicantStatus.key);
            setApplicantStatus(jobApplication.applicantStatus.key);
            setStatusvalue(jobApplication.applicantStatus.value);
          }

          if (jobApplication.interviewType !== null) {
            setInterviewType(jobApplication.interviewType.key);
          }

          if (jobApplication.days !== null) {
            setAppliedDays(jobApplication.days);
          }

          if (jobApplication.modifiedDays !== null) {
            setModifiedDays(jobApplication.modifiedDays);
          }

          if (jobApplication.applieddOn !== null) {
            setApplieddOn(jobApplication.applieddOn);
          }

          if (jobApplication.modifiedOn !== null) {
            setModifiedOn(jobApplication.modifiedOn);
          }
        }

        setCertifications(candidate.certifications.skills);
        setSoftSkills(candidate.softSkills.skills);
        setLanguages(candidate.langs.languages);
        sethighlights(candidate.highlights.highlights);
        setExperienceList(candidate.expList.exps);
        filterExperience(candidate.expList.exps);
        setEducationList(candidate.eduList.eduList);
        filterEdu(candidate.eduList.eduList);

        if (candidateJobpref != null) {
          setJobPrep(candidateJobpref);
          setEmpTerm(candidateJobpref.empTerm.value);
          setJobStatus(candidateJobpref.jobStatus.value);
          setJobType(candidateJobpref.jobType.value);
          setJobShift(candidateJobpref.shifts.value);
        }

        setFiles(candidate.files.files);

        setBasicInfo(basicInfo);
        setLocation(address);
        if (candidateJobpref.address != null) {
          setCity(candidateJobpref.address.city);
          setState(candidateJobpref.address.state);
          setCountry(candidateJobpref.address.country);
        }

        if (onjobSkills.length > 0) {
          const jobSkillData = [];
          onjobSkills.map((jobskill, index) => {
            jobskill.rating = 0;
            if (candidateSkills.length > 0) {
              candidateSkills.map((otherskill, index1) => {
                if (jobskill.skillId == otherskill.skillId) {
                  jobskill.rating = otherskill.rating;
                }
              });
            }
            jobSkillData.push(jobskill);
          });
          setJobSkills(jobSkillData);
        }
        if (candidateSkills != null) {
          const skillData = [];
          candidateSkills.map((otherskills, index1) => {
            if (onjobSkills != null) {
              const isFound = onjobSkills.some((element) => {
                if (element.skillId === otherskills.skillId) {
                  return true;
                }
                return false;
              });
              if (isFound) {
              } else {
                skillData.push(otherskills);
                setFilteredSkills(skillData);
              }
            }
          });
        }

        if (jobApplication != null) {
          if (
            jobApplication.applicantStatus.key == "TA_SHORT_LISTED" ||
            jobApplication.applicantStatus.key == "TA_REJECTED" ||
            jobApplication.applicantStatus.key == "APPLIED"
          ) {
            setShowShortlisted(true);
          } else {
            setShowShortlisted(false);
          }
          if (jobApplication.applicantStatus.key == "TA_REJECTED") {
            setShortlisted(false);

            SetTareject(true);
          }

          if (jobApplication.applicantStatus.key == "TA_SHORT_LISTED") {
            setShortlisted(true);
            setInterviewScheduled(false);
            setInterviewRequested(false);
            setInterviewCompleted(false);
            SetTareject(false);
          }

          if (jobApplication.applicantStatus.key == "INTERVIEW_SCHEDULED") {
            setInterviewScheduled(true);
          }
          if (jobApplication.applicantStatus.key == "INTERIVIEW_REQUESTED") {
            setInterviewRequested(true);
          }
          if (jobApplication.applicantStatus.key == "INTERIVIEW_COMPLETED") {
            setInterviewCompleted(true);
          }

          setAdlReasons(jobApplication.adlReasons);
          setClientComment(jobApplication.clientComment);
          setClientQuestion(jobApplication.clientQuestion);
          setClientAcceptanceNotes(jobApplication.clientAcceptanceNotes);
          setClientRejectReason(jobApplication.clientRejectReason);
          setTaActionRequired(jobApplication.taActionRequired);
        }
        if (job.jobDetails != null) {
          setJobReqStatus(job.jobDetails.jobStatus.key);
          if (job.jobDetails.jobStatus.key === "CLOSED") {
            setChecked(true);
          }
        }
      }
    );
  };

  const getShortlistedReasons = () => {
    JobService.getShortlistReasonService(
      applicationId,
      jobreqid,
      searchId
    ).then((response) => {
      if (response.data != null) {
        const candReviewshortlistedDetails = response.data;
        if (candReviewshortlistedDetails != null) {
          setRelevantJobExp(candReviewshortlistedDetails.relevantJobExp);
          setRelevantEdu(candReviewshortlistedDetails.relevantEdu);
          setStrongSkillFit(candReviewshortlistedDetails.strongSkillFit);
          setRelevantLanguages(candReviewshortlistedDetails.relevantLanguages);
          setGrtSoftSkillFit(candReviewshortlistedDetails.grtSoftSkillFit);
          setAskCandidateQuestions(
            candReviewshortlistedDetails.askCandidateQuestions
          );
        }
      }
    });
  };

  const getRejectedReasons = () => {
    JobService.getRejectedReasonService(applicationId, jobreqid, searchId).then(
      (response) => {
        if (response.data != null) {
          const candReviewrejectDetails = response.data;
          if (candReviewrejectDetails != null) {
            setJobTenure(candReviewrejectDetails.jobTenure);
            setSalaryExpectations(candReviewrejectDetails.salaryExpectations);
            setInsuffOrIrrelevantEdu(
              candReviewrejectDetails.insuffOrIrrelevantEdu
            );
            setInsuffOrIrrelevantExp(
              candReviewrejectDetails.insuffOrIrrelevantExp
            );
            setMissingLicencesOrCerts(
              candReviewrejectDetails.missingLicencesOrCerts
            );
            setSelectedAnotherCandidate(
              candReviewrejectDetails.selectedAnotherCandidate
            );
            setPrevRejectedCandidate(
              candReviewrejectDetails.prevRejectedCandidate
            );
            setPoorInterview(candReviewrejectDetails.poorInterview);
            setNoShow(candReviewrejectDetails.noShow);
            setHiringOfferDeclined(candReviewrejectDetails.hiringOfferDeclined);
          }
        }
      }
    );
  };

  const changeApplicantJobStatus = () => {
    const shortListReasons = {
      relevantJobExp: relevantJobExp,
      relevantEdu: relevantEdu,
      strongSkillFit: strongSkillFit,
      relevantLanguages: relevantLanguages,
      grtSoftSkillFit: grtSoftSkillFit,
      askCandidateQuestions: askCandidateQuestions,
    };

    const rejectReasons = {
      jobTenure: jobTenure,
      salaryExpectations: salaryExpectations,
      insuffOrIrrelevantExp: insuffOrIrrelevantExp,
      insuffOrIrrelevantEdu: insuffOrIrrelevantEdu,
      missingLicencesOrCerts: missingLicencesOrCerts,
      selectedAnotherCandidate: selectedAnotherCandidate,
      prevRejectedCandidate: prevRejectedCandidate,
      poorInterview: poorInterview,
      noShow: noShow,
      hiringOfferDeclined: hiringOfferDeclined,
    };

    const shortListObj = {
      status: applicantStatus,
      adlReasons: additionalReasons,
      shortListReasons: shortListReasons,
    };

    const rejectObj = {
      status: applicantStatus,
      adlReasons: additionalReasons,
      rejectReasons: rejectReasons,
    };
    const interviewScheduledObj = {
      status: applicantStatus,
      adlReasons: additionalReasons,
      interviewType: interviewType,
    };

    const declinedObj = {
      status: applicantStatus,
      clientRejectReason: additionalReasons,
    };
    const selectedForHireObj = {
      status: applicantStatus,
      clientAcceptanceNotes: additionalReasons,
    };
    const dataObj = {
      status: applicantStatus,
      adlReasons: additionalReasons,
    };

    if (applicantStatus == "") {
      toast.error("Please select a status");
    } else if (applicantStatus == "TA_SHORT_LISTED") {
      JobService.changeApplicantJobStatusService(
        applicationId,
        shortListObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate status changed to new candidate");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else if (applicantStatus == "TA_REJECTED") {
      JobService.changeApplicantJobStatusService(
        applicationId,
        rejectObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate rejected successfully");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else if (
      applicantStatus == "INTERVIEW_SCHEDULED" ||
      applicantStatus == "INTERIVIEW_REQUESTED" ||
      applicantStatus == "INTERIVIEW_COMPLETED"
    ) {
      JobService.changeApplicantJobStatusService(
        applicationId,
        interviewScheduledObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          if (applicantStatus == "INTERVIEW_SCHEDULED") {
            toast.success("Candidate interview scheduled successfully");
          } else if (applicantStatus == "INTERIVIEW_REQUESTED") {
            toast.success("Candidate interview requested successfully");
          } else if (applicantStatus == "INTERIVIEW_COMPLETED") {
            toast.success("Candidate interview completed successfully");
          }

          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else if (applicantStatus === "DECLINED") {
      JobService.changeApplicantJobStatusService(
        applicationId,
        declinedObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate declined successfully");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else if (applicantStatus === "REJECTED") {
      JobService.changeApplicantJobStatusService(
        applicationId,
        declinedObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate rejected successfully");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else if (applicantStatus == "WITHDRAWN") {
      JobService.changeApplicantJobStatusService(
        applicationId,
        dataObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate withdrawn successfully");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else if (applicantStatus == "WITHDRAWN_POST") {
      JobService.changeApplicantJobStatusService(
        applicationId,
        dataObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate withdrawn successfully");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else if (applicantStatus == "ARCHIVE") {
      JobService.changeApplicantJobStatusService(
        applicationId,
        dataObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate archive successfully");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else if (applicantStatus == "JOINED") {
      JobService.changeApplicantJobStatusService(
        applicationId,
        dataObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate joined successfully");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    } else {
      JobService.changeApplicantJobStatusService(
        applicationId,
        dataObj,
        jobreqid,
        searchId
      ).then((response) => {
        if (response.data != null) {
          toast.success("Candidate status updated successfully");
          getCandidateReviewDetails();
          getTaNotes();
        }
      });
    }
  };
  const addTaNotes = () => {
    const addedNotes = notesAdded;
    if (isNullOrEmpty(addedNotes) || !addedNotes.trim().length) {
      toast.error("Please enter the notes");
      return;
    }
    const str = addedNotes;
    const message = str.replace(/@\[([^\]]+)\]\([^\)]+\)/g, "@$1");
    var arr = getSelectedusers(message);
    const reqObj = {
      commentedById: userId,
      notes: message,
      mentions: arr,
    };

    JobService.addTaNotes(reqObj, applicationId, jobreqid).then((response) => {
      if (response.data != null) {
        toast.success("Notes added succesfully");
        getTaNotes();
        setNotesAdded("");
        return;
      }
    });
  };

  const getSelectedusers = (input) => {
    var arr = [];
    if (selectedMentions.length > 0) {
      for (let i = 0; i < selectedMentions.length; i++) {
        let selectedMentionId = selectedMentions[i].id;
        arr.push(selectedMentionId);
      }
    }
    console.log("getSelectedusersjobresume" + JSON.stringify(arr));

    return arr;
  };

  const displayModal = (id) => {
    setSelectedNoteId(id);
    setModalcopy(true);
  };

  const deleteTaNotes = () => {
    JobService.deleteNotes(applicationId, selectedNoteId, jobreqid).then(
      (response) => {
        try {
          if (response.data !== null) {
            toast.success("The TA notes is deleted successfully");
            setModalcopy(false);
            getTaNotes();
            return;
          }
        } catch (err) {
          setModalcopy(false);
          toast.error("User not authorized");
          console.log("error" + JSON.stringify(err.message));
        }
      }
    );
  };

  const navigateTo = () => {
    if (props.location.state != undefined) {
      if (props.location.state.componentName == "searchCandidates") {
        history.push(`/searchcandidates`);
      } else if (props.location.state.componentName == "notifications") {
        history.push(`/notifications`);
      } else if (props.location.state.componentName == "addrequest") {
        history.push(`/addrequest/${jobRequestId}?t=candidates`);
      }
    } else {
      history.push(`/requests`);
    }
  };

  const handleInterviewTypeChange = (e) => {
    setInterviewType(e.target.value);
  };

  function handleStatusChange(e) {
    setAdditionalReasons("");
    setApplicantStatus(e.target.value);

    if (e.target.value == "TA_SHORT_LISTED") {
      setShortlisted(true);
      setInterviewScheduled(false);
      setInterviewRequested(false);
      setInterviewCompleted(false);

      SetTareject(false);
    } else if (e.target.value == "REJECTED") {
      setShortlisted(false);
      SetTareject(false);
      setInterviewScheduled(false);
      setInterviewRequested(false);
      setInterviewCompleted(false);
    } else if (e.target.value == "TA_REJECTED") {
      setShortlisted(false);
      SetTareject(true);
      setInterviewScheduled(false);
      setInterviewRequested(false);
      setInterviewCompleted(false);
    } else if (e.target.value == "INTERVIEW_SCHEDULED") {
      setInterviewScheduled(true);
      setInterviewRequested(false);
      setInterviewCompleted(false);
      setInterviewType("IN_PERSON");
      setShortlisted(false);

      SetTareject(false);
    } else if (e.target.value == "INTERIVIEW_REQUESTED") {
      setInterviewRequested(true);
      setInterviewScheduled(false);
      setInterviewCompleted(false);
      setInterviewType("IN_PERSON");
      setShortlisted(false);

      SetTareject(false);
    } else if (e.target.value == "INTERIVIEW_COMPLETED") {
      setInterviewCompleted(true);
      setInterviewScheduled(false);
      setInterviewRequested(false);
      setInterviewType("IN_PERSON");
      setShortlisted(false);

      SetTareject(false);
    } else if (e.target.value == "SELECTED_FOR_HIRE") {
      setInterviewScheduled(false);
      setInterviewRequested(false);
      setInterviewCompleted(false);
      setShortlisted(false);

      SetTareject(false);
    } else {
      setInterviewScheduled(false);
      setInterviewRequested(false);
      setInterviewCompleted(false);
      setShortlisted(false);

      SetTareject(false);
    }
  }

  const getProxyLoginDetails = () => {
    JobService.proxyLogin(candidateId, searchId).then((response) => {
      var jobDetails = response.data;
      window.open(
        ENV.candidate_web_url +
          "?p=proxylogin&authToken=" +
          window.localStorage.getItem("authToken") +
          "&candidateId=" +
          candidateId,
        "candidateprofile"
      );
    });
  };
  const updateTAActed = () => {
    setShow((prev) => !prev);

    JobService.taActionCompletedService(applicationId, jobreqid).then(
      (response) => {
        var jobDetails = response.data;
        if (jobDetails != null) {
          toast.success("Action Completed successfully");
        }
      }
    );
  };

  const getcandidateNotesHistory = () => {
    JobService.notesHistory(applicationId, jobreqid).then((response) => {
      if (response.data !== null) {
        // setTaNotes(response.data.notes);
        setNotesHistory(response.data.notes);
      }
    });
  };

  const getScore = (value) => {
    const score = (value / 20).toFixed(1);
    return score;
  };
  const showAdditionalReasonsMessage = (status) => {
    if (status === "SELECTED_FOR_HIRE") {
      return <p>{clientAcceptanceNotes}</p>;
    } else if (status === "INTERVIEW_SCHEDULED") {
      return <p>{adlReasons}</p>;
    } else if (status === "DECLINED" || status === "REJECTED") {
      return <p>{clientRejectReason}</p>;
    } else {
      return <p>{adlReasons}</p>;
    }
  };
  const showSkills = (skills) => {
    return skills.map((skill, index) => {
      return (
        <div key={skill.skillId+index}>
          <div className="row mt-2">
            <div className="col-sm-6">
              <div className="review-doc">
                <label> {skill.name}</label>
              </div>
            </div>
            <div className="col-sm-6">
              <ReactStars
                count={5}
                edit={false}
                size={18}
                value={skill.rating}
                id={skill.id + "_rating"}
              ></ReactStars>
            </div>
          </div>
        </div>
      );
    });
  };
  const getAddress = (addressObj) => {
    const address = [];
    if (addressObj != null) {
      if (addressObj.city != null) {
        address.push(addressObj.city + ", ");
      }
      if (addressObj.state != null) {
        address.push(addressObj.state);
      }
    }
    return address;
  };

  const salaryType = (salary) => {
    if (salary === "yearly") {
      return "year";
    }
    if (salary === "hourly") {
      return "hour";
    }
    if (salary === "monthly") {
      return "month";
    }
  };

  const showSalary = (minSal, maxSal) => {
    return "$" + minSal.toLocaleString() + "-" + "$" + maxSal.toLocaleString();
  };
  const showSalaryType = (salType) => {
    if (!isNullOrEmpty(salType)) {
      return "/" + salaryType(salType.value);
    }
  };
  const showRequiredAddress = (add) => {
    var arr = [];
    if (!isNullOrEmpty(add)) {
      if (!isNullOrEmpty(add.area)) {
        arr.push(add.area);
      }
      if (!isNullOrEmpty(add.city)) {
        arr.push(add.city);
      }
      if (!isNullOrEmpty(add.state)) {
        arr.push(add.state);
      }
      if (!isNullOrEmpty(add.zipcode)) {
        arr.push(add.zipcode);
      }
      return arr.join(", ");
    }
    return "";
  };
  const showWorkRadiusMessage = (workRadius, reqAdd) => {
    var message = "";
    if (workRadius === -1) {
      message = "Will relocate anywhere in the US";
    } else if (workRadius === -2) {
      message = "Work from home only";
    } else if (workRadius > 0) {
      message =
        "Up to  " + workRadius + " miles from " + showRequiredAddress(reqAdd);
    }
    return message;
  };

  const [filteredPresentList, setFilteredPresentList] = useState([]);
  const [filterededuList, setFilterededuList] = useState([]);
  const filterExperience = (exp) => {
    var x = exp.filter((expItem) => expItem.endDate === 0);
    var p1 = sortArray(x, { by: "startDate", order: "desc" });
    var y = exp.filter(
      (expItem) => expItem.endDate !== 0 && expItem.startDate !== 0
    );
    var z = exp.filter((expItem) => expItem.startDate === 0);
    setFilteredPresentList([...z, ...p1, ...y]);
  };
  const filterEdu = (eduList) => {
    var x1 = eduList.filter((expItem) => expItem.endDate === 0);
    var p2 = sortArray(x1, { by: "startDate", order: "desc" });
    var y1 = eduList.filter(
      (expItem) => expItem.endDate !== 0 && expItem.startDate !== 0
    );
    var p3 = sortArray(y1, { by: "startDate", order: "desc" });
    var z1 = eduList.filter((expItem) => expItem.startDate === 0);
    setFilterededuList([...z1, ...p2, ...p3]);
  };

  const copyLPUrl = () => {
    var templateUrl =
      ENV.candidate_web_url +
      "?p=jobreq&jobId=" +
      window.localStorage.getItem("requestId");
    if (!isNullOrEmpty(window.localStorage.getItem("requestId"))) {
      let jobId = window.localStorage.getItem("requestId");
      JobService.getJob(jobId).then((response) => {
        let landingPageTemplate = "";
        let landingPageTemplateFields = [];
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
            }
          } else {
            if (response.data != null) {
              var jobDetails = response.data;
              if (!isNullOrEmpty(jobDetails.landingPageTemplate)) {
                landingPageTemplate = jobDetails.landingPageTemplate;
                templateUrl =
                  templateUrl + "&templateName=" + landingPageTemplate;
              }

              if (jobDetails.landingPageFields !== null) {
                landingPageTemplateFields = jobDetails.landingPageFields;
                if (landingPageTemplateFields.length > 0) {
                  landingPageTemplateFields.forEach((template) => {
                    let name = template.name;
                    let value = template.value;
                    templateUrl = templateUrl + "&" + name + "=" + value;
                  });
                }
              }
              displayTemplateUrl(templateUrl);
            } else {
              displayTemplateUrl(templateUrl);
            }
          }
        } catch (err) {
          console.log("message" + JSON.stringify(err.message));
          displayTemplateUrl(templateUrl);
        }
      });
    } else {
      displayTemplateUrl(templateUrl);
    }
  };

  const displayTemplateUrl = (templateUrl) => {
    const el = document.createElement("input");
    el.value = encodeURI(templateUrl);
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    window.open(encodeURI(templateUrl));
  };
  const showDeleteIcon = (
    autoGen,
    indx,
    id,
    commentedById,
    notes
  ) => {
    let delId = id;
    if (userId === commentedById) {
      if (autoGen === false && indx === 0) {
        return (
          <>
            <i
              className="  simple-icon-note edit-copyiconsize arrow-icon-color mr-2 emp_icon  t-cursor-pointer btn-sm"
              title="Edit Member"
              outline="true"
              color="primary"
              onClick={(e) => {
                UpdateTaNotes(notes);
              }}
            />
            <i
              className="mb-2 simple-icon-trash edit-copyiconsize arrow-icon-color mr-1 emp_icon"
              onClick={() => displayModal(delId)}
            />
          </>
        );
      }
    }
  };
  const showMonthYear = (longDate) => {
    if (longDate === 0) {
      return;
    }
    var date = new Date(longDate);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return months[date.getMonth()] + " " + date.getFullYear();
  };

  const UpdateTaNotes = (notes) => {
    setSelectedNoteId(notes.id);
    setModalBasic(true);
    setTaSelectedNotes(notes.notes);
  };

  const updateTaNotes = () => {
    if (isNullOrEmpty(taSelectedNotes)) {
      toast.error("Please add notes");
    }

    const str = taSelectedNotes;

    const message = str.replace(/@\[([^\]]+)\]\([^\)]+\)/g, "@$1");
    var arr = getSelectedusers(message);

    const UpdatenotesObj = {
      commentedById: userId,
      notes: message,
      mentions: arr,
    };
    JobService.updateTaNotes(
      jobreqid,
      UpdatenotesObj,
      applicationId,
      selectedNoteId
    ).then((response) => {
      if (response.data !== null) {
        toast.success("Notes updated successfully");
        getTaNotes();
        setNotesAdded("");

        // setTaNotes(response.data.notes);
        return;
      }
    });
    setModalBasic(false);
  };

  const showLocation = () => {
    const arr = [];
    if (!isNullOrEmpty(city)) {
      arr.push(city);
    }
    if (!isNullOrEmpty(state)) {
      arr.push(state);
    }

    if (arr.length > 0) {
      return (
        <>
          <Col>
            <Row className="mt-2" sm={1}>
              <Col sm={1}>
                <GrLocation
                  className="account-sm-logo"
                  title="Current Location"
                />
              </Col>
              <Col className="alignment" sm={10}>
                {arr.join(", ")}
              </Col>
            </Row>
          </Col>
        </>
      );
    }

    return;
  };

  const handleChange = (event, newValue, newPlainTextValue, mentions) => {
    setNotesAdded(event.target.value);
    setSelectedMentions(mentions);
  };

  const updatedHandleChange = (
    event,
    newValue,
    newPlainTextValue,
    mentions
  ) => {
    setTaSelectedNotes(event.target.value);
    setSelectedMentions(mentions);
  };

  const ComponentToPrint = React.forwardRef((props, ref) => {
    return (
      <>
        <Colxx xxs="12" xl="9" className="col-left ">
          <Card className="mb-4 t-rounded-xl">
            <Row>
              <Colxx xxs="12" xl="11" className="col-left "></Colxx>
              <Colxx
                xxs="12"
                xl="1"
                id="printdiv"
                className="dontprint col-right mt-2"
              >
                <ReactToPrint
                  trigger={() => {
                    return (
                      <i
                        title="Print resume"
                        className="simple-icon-printer review-icon t-cursor-pointer"
                      ></i>
                    );
                  }}
                  content={() => componentRef.current}
                  documentTitle={basicInfo.firstName}
                  pageStyle="print"
                />
              </Colxx>
            </Row>
            <div ref={ref}>
              <CardBody>
                <Container>
                  <Row>
                    <Col xs={6} className="Ta_details">
                      <Row>
                        <Col className="col-left">
                          <div className="">
                            <div className="form-review">
                              <div className="title">
                                {basicInfo.firstName != null &&
                                  basicInfo.firstName !== "" && (
                                    <>
                                      {basicInfo.firstName +
                                        " " +
                                        basicInfo.lastName}
                                    </>
                                  )}
                              </div>
                            </div>
                          </div>
                        </Col>{" "}
                      </Row>
                      <Row>
                        {basicInfo.email == "" || basicInfo.email == null ? (
                          <></>
                        ) : (
                          <>
                            <Col className="mt-2 " sm={1}>
                              {" "}
                              <div>
                                <GoMail
                                  className="account-sm-logo"
                                  title="Email"
                                />
                              </div>
                            </Col>
                            <Col className="mt-2" sm={10}>
                              {" "}
                              <div>{basicInfo.email}</div>
                            </Col>
                          </>
                        )}
                      </Row>
                      <Row>
                        {" "}
                        {isNullOrEmpty(basicInfo.contactNumber) ? (
                          <></>
                        ) : (
                          <>
                            <Col className="mt-2 " sm={1}>
                              {" "}
                              <MdOutlinePhoneIphone
                                className="account-sm-logo"
                                title="Phone"
                              />{" "}
                            </Col>
                            <Col className="alignment">
                              {" "}
                              {formattedMobileNumber(basicInfo.contactNumber)}
                            </Col>
                          </>
                        )}
                      </Row>

                      <Row>{showLocation(city, state)}</Row>
                      <Row className="mt-2">
                        {!isNullOrEmpty(jobpref.availability) && (
                          <Col>
                            <Row>
                              <Col sm={1}>
                                <IoCalendarNumberOutline
                                  className="account-sm-logo"
                                  title="Availability to join"
                                />
                              </Col>
                              <Col className="alignment">
                                {jobpref.availability}
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Row>
                      <Row>
                        {jobpref.salaryMin >= 0 && jobpref.salaryMax > 0 && (
                          <>
                            <Col sm={1}>
                              <CgDollar
                                className="account-sm-logo"
                                title="Desired Salary"
                              />
                            </Col>
                            <Col className="alignment mt-1">
                              {showSalary(
                                jobpref.salaryMin,
                                jobpref.salaryMax
                              ) + showSalaryType(jobpref.salaryType)}
                            </Col>
                          </>
                        )}
                      </Row>
                    </Col>
                    <Col xs={6}>
                      {(() => {
                        if (skillFit >= 80) {
                          return (
                            <Colxx className="col-right mt-4">
                              <Row>
                                <Col md={4}>
                                  <CircularProgressbarWithChildren
                                    value={peerRatingScore}
                                  >
                                    <div
                                      style={{ fontSize: 12 }}
                                      className="fitscoreavg"
                                    >
                                      <strong>FIt Score</strong>
                                    </div>
                                    <h1 style={{ textAlign: "center" }}>
                                      {getScore(peerRatingScore)}
                                    </h1>
                                  </CircularProgressbarWithChildren>
                                </Col>
                                <Col>
                                  <div className="mb-1">
                                    <p className="mb-2">Skill Fit</p>
                                    <Progress value={skillFitScore} />
                                  </div>

                                  <div className="mb-1">
                                    <p className="mb-2">Job Preferences Fit</p>
                                    <Progress value={jobPrefScore} />
                                  </div>
                                </Col>
                              </Row>
                              <div>
                                <Row className="col-12">
                                  <Colxx className="col-3"></Colxx>
                                </Row>
                              </div>
                            </Colxx>
                          );
                        }
                      })()}
                    </Col>
                  </Row>
                </Container>
              </CardBody>
              <div>
                <Row>
                  <Colxx xxs="12" xl="11" className="col-left"></Colxx>

                  <Colxx xxs="12" xl="1" className="col-right mt-4">
                    <div></div>
                  </Colxx>
                </Row>
                <Row></Row>

                <div>
                  <Row>
                    <Colxx sm={12}>
                      <Row className="ml-3 mb-5 ">
                        <Colxx
                          sm={4}
                          className="t-review_menu_col_menu min-sm:bg-primary-lightblue"
                        >
                          {softSkills.length > 0 && (
                            <div>
                              <div className="font-bold text-lg">
                                Soft Skills
                              </div>
                              <Separator className="mb-3 t-border-primary-blue2  t-border-b-2 "></Separator>
                              {softSkills.map((softskill,index) => {
                                return (
                                  <div key={index}>
                                    <div className="review-doc">
                                      <label> {softskill.name}</label>
                                    </div>

                                    {/* <Separator className="mb-1"></Separator> */}
                                  </div>
                                );
                              })}
                            </div>
                          )}

                          {languages.length > 0 && (
                            <div>
                              <div className="font-bold text-lg  mt-4">
                                Languages
                              </div>
                              <Separator className="mb-3 t-border-primary-blue2  t-border-b-2"></Separator>
                              {languages.map((language,index) => {
                                return (
                                  <div key={index}>
                                    <div className="basis-[48%] py-3 text-center bg-primary-gray t-rounded-xl min-sm:bg-white ">
                                      <div className="review-doc">
                                        <label>
                                          {" "}
                                          {language.description +
                                            "  Spoken"}{" "}
                                        </label>
                                      </div>
                                      <div className="inline-block text-center items-center justify-center my-2">
                                        <ReactStars
                                          count={5}
                                          id={
                                            language.skillId + "_spokenrating"
                                          }
                                          size={18}
                                          edit={false}
                                          value={language.ratingSpoken}
                                          activeColor="#ffd700"
                                        />
                                      </div>
                                    </div>
                                    <div className="basis-[48%] py-3 text-center bg-primary-gray t-rounded-xl min-sm:bg-white mb-3 mt-3">
                                      <div className="review-doc">
                                        <label>
                                          {language.description + "  Written"}
                                        </label>
                                      </div>
                                      <div className="inline-block text-center items-center justify-center my-2">
                                        <ReactStars
                                          count={5}
                                          id={
                                            language.skillId + "_writtenrating"
                                          }
                                          size={18}
                                          edit={false}
                                          value={language.ratingWritten}
                                          activeColor="#ffd700"
                                        />
                                      </div>
                                    </div>
                                    {/* <Separator className="mb-1"></Separator> */}
                                  </div>
                                );
                              })}
                            </div>
                          )}

                          {certifications.length > 0 && (
                            <div>
                              <div className="font-bold text-lg  mt-4">
                                Certificate(s)
                              </div>
                              <Separator className="mb-3 t-border-primary-blue2  t-border-b-2"></Separator>
                              {certifications.map((certification, index) => {
                                return (
                                  <div className="review-doc" key={index}>
                                    <ul>
                                      <li className="my-3">
                                        <svg
                                          width="12"
                                          height="16"
                                          viewBox="0 0 12 16"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="inline mr-1"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5ZM0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6Z"
                                            fill="#1F9DFC"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6 3.5C4.61929 3.5 3.5 4.61929 3.5 6C3.5 7.38071 4.61929 8.5 6 8.5C7.38071 8.5 8.5 7.38071 8.5 6C8.5 4.61929 7.38071 3.5 6 3.5ZM2.5 6C2.5 4.067 4.067 2.5 6 2.5C7.933 2.5 9.5 4.067 9.5 6C9.5 7.933 7.933 9.5 6 9.5C4.067 9.5 2.5 7.933 2.5 6Z"
                                            fill="#1F9DFC"
                                          />
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M3 9.5C3.27614 9.5 3.5 9.72386 3.5 10V14.191L5.77639 13.0528C5.91716 12.9824 6.08284 12.9824 6.22361 13.0528L8.5 14.191V10C8.5 9.72386 8.72386 9.5 9 9.5C9.27614 9.5 9.5 9.72386 9.5 10V15C9.5 15.1733 9.41027 15.3342 9.26287 15.4253C9.11546 15.5164 8.93139 15.5247 8.77639 15.4472L6 14.059L3.22361 15.4472C3.06861 15.5247 2.88454 15.5164 2.73713 15.4253C2.58973 15.3342 2.5 15.1733 2.5 15V10C2.5 9.72386 2.72386 9.5 3 9.5Z"
                                            fill="#1F9DFC"
                                          />
                                        </svg>
                                        {certification.name}
                                      </li>
                                    </ul>
                                    {/* <label>{certification.name}</label> */}
                                    {/* <Separator className="mb-1"></Separator> */}
                                  </div>
                                );
                              })}
                            </div>
                          )}

                          {files.length > 0 && (
                            <div>
                              <div className="font-bold text-lg  mt-4">
                                Document(s)
                              </div>
                              <Separator className="t-border-primary-blue2  t-border-b-2"></Separator>
                              {files.map((file,index) => (
                                <Row key={index} className="mt-2">
                                  <Colxx>
                                    <Row>
                                      <Colxx>
                                        <div className="review-doc">
                                          <a
                                            title="Download document"
                                            href={file.fileKey}
                                            className="mr-2 "
                                          >
                                            <>
                                              <i className=" simple-icon-cloud-download download-icon"></i>
                                            </>
                                          </a>
                                          <label>{file.name}</label>
                                          {/* <Separator className="mb-1"></Separator> */}
                                        </div>
                                      </Colxx>
                                    </Row>
                                  </Colxx>
                                </Row>
                              ))}
                            </div>
                          )}

                          <div>
                            <div className="font-bold text-lg mt-4 ">
                              Job Preferences
                            </div>
                            <Separator className=" t-border-primary-blue2 t-border-b-2"></Separator>

                            <Row className="mt-2">
                              <Colxx>
                                <Row>
                                  <Colxx>
                                    <Card className="t-rounded-xl">
                                      <CardBody>
                                        {jobpref !== null && (
                                          <Row>
                                            <Colxx sm={12}>
                                              <label>
                                                {showWorkRadiusMessage(
                                                  jobpref.workRadius,
                                                  jobpref.address
                                                )}
                                              </label>
                                            </Colxx>
                                            <Colxx sm={12}>
                                              <label>{jobStatus}</label>
                                            </Colxx>
                                            <Colxx sm={12}>
                                              <label>{jobType}</label>
                                            </Colxx>
                                            <Colxx sm={12}>
                                              <label>{empTerm}</label>
                                            </Colxx>
                                            <Colxx sm={12}>
                                              <label>{jobShift}</label>
                                            </Colxx>
                                          </Row>
                                        )}
                                      </CardBody>
                                    </Card>
                                  </Colxx>
                                </Row>
                              </Colxx>
                            </Row>
                          </div>
                        </Colxx>
                        <Colxx sm={8} className=" mt-3 t-width-exp">
                          <>
                            <div className="ml-3">
                              <div className=" font-bold text-lg">
                                Career Highlights
                              </div>
                              <Separator className="mb-3 mr-3 t-border-primary-blue2  t-border-b-2"></Separator>

                              {highlights.length > 0 &&
                                highlights.map((highlight, index) => {
                                  return (
                                    <div className="row mt-2" key={index}>
                                      <div className="col-sm-12">
                                        <div className="review-doc">
                                          {/* <FiStar className="  text-warning"></FiStar> */}
                                          <img
                                            src={squarebullet}
                                            className="t-diamond-size-career mr-2"
                                          ></img>
                                          {highlight}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>

                            <div className="ml-3 mt-3">
                              <div className=" font-bold text-lg">Skills</div>
                              <Separator className="mb-3 mr-3 t-border-primary-blue2 t-border-b-2"></Separator>
                              <Nav
                                tabs
                                className="separator-tabs t-border-primary-blue2 t-border-b-2  mr-3  ml-0 mb-5"
                              >
                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === "jobRelated",
                                      "nav-link": true,
                                    })}
                                    onClick={() => setActiveTab("jobRelated")}
                                    to="#"
                                    location={{}}
                                  >
                                    Job Related
                                  </NavLink>
                                </NavItem>

                                <NavItem>
                                  <NavLink
                                    className={classnames({
                                      active: activeTab === "Other",
                                      "nav-link": true,
                                    })}
                                    onClick={() => setActiveTab("Other")}
                                    to="#"
                                    location={{}}
                                  >
                                    Other
                                  </NavLink>
                                </NavItem>
                              </Nav>

                              <TabContent activeTab={activeTab}>
                                <TabPane tabId="jobRelated">
                                  {jobSkills.length > 0 &&
                                    showSkills(jobSkills)}
                                </TabPane>

                                <TabPane tabId="Other">
                                  {filteredSkills.length > 0 &&
                                    showSkills(filteredSkills)}
                                </TabPane>
                              </TabContent>
                            </div>

                            <div className="mb-3 ml-3">
                              <div className="font-bold text-lg">
                                Job Experience
                              </div>
                              <Separator className="mb-3 mr-3 t-border-primary-blue2 t-border-b-2"></Separator>
                              {filteredPresentList.length > 0 &&
                                filteredPresentList.map((experience, index) => {
                                  return (
                                    <div key={index}>
                                      <div className=" form-review">
                                        <div className=" font-semibold text-lg text-primary-blue pragrap_pad mt-3">
                                          {experience.position}
                                        </div>
                                        <div>{experience.employer}</div>

                                        <div className="form-review">
                                          {experience.address !== null ? (
                                            <>
                                              {getAddress(experience.address)}
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                        <div className="form-review t-fnt-semibold">
                                          <p className="fnt_semibold text-sm pragrap_pad">
                                            {experience.startDate == 0 ? (
                                              <></>
                                            ) : (
                                              <>
                                                {experience.startDate !== 0 &&
                                                experience.endDate == 0 ? (
                                                  <>
                                                    {showMonthYear(
                                                      experience.startDate
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    {showMonthYear(
                                                      experience.startDate
                                                    )}{" "}
                                                    -{" "}
                                                    {showMonthYear(
                                                      experience.endDate
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}{" "}
                                            {experience.startDate == 0 ||
                                            experience.endDate == 0 ? (
                                              <></>
                                            ) : (
                                              <>
                                                (
                                                {getDateDifference(
                                                  experience.startDate,
                                                  experience.endDate
                                                )}
                                                )
                                              </>
                                            )}
                                          </p>
                                        </div>
                                        {experience.description ? (
                                          <>
                                            <div className=" mt-4  bg-primary-lightblue t-rounded-xl px-7 py-3 list-disc t-parsed-text">
                                              {experience.description}
                                            </div>
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>

                            <div className="ml-3">
                              <div className="font-bold text-lg ">
                                Education
                              </div>
                              <Separator className="mb-3 mr-3 t-border-primary-blue2 t-border-b-2"></Separator>

                              {filterededuList.length > 0 &&
                                filterededuList.map((education, index) => {
                                  return (
                                    <div key={index}>
                                      <div className="form-review">
                                        <div className=" font-semibold text-lg text-primary-blue pragrap_pad mt-3">
                                          {education.major}
                                        </div>
                                        <div>{education.school}</div>

                                        <div className="form-review">
                                          {education.address !== null ? (
                                            <>{getAddress(education.address)}</>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                        <div className="form-review t-fnt-semibold">
                                          {education.endDate == 0 ? (
                                            <></>
                                          ) : (
                                            <>
                                              {education.startDate == 0 &&
                                              education.endDate !== 0 ? (
                                                <>
                                                  {showMonthYear(
                                                    education.endDate
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {showMonthYear(
                                                    education.startDate
                                                  )}{" "}
                                                  -{" "}
                                                  {showMonthYear(
                                                    education.endDate
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}{" "}
                                          {education.startDate == 0 ||
                                          education.endDate == 0 ? (
                                            <></>
                                          ) : (
                                            <>
                                              (
                                              {getDateDifference(
                                                education.startDate,
                                                education.endDate
                                              )}
                                              )
                                            </>
                                          )}
                                        </div>

                                        {education.description ? (
                                          <>
                                            <div className=" mt-4  bg-primary-lightblue t-rounded-xl px-7 py-3 list-disc t-parsed-text">
                                              {education.description}
                                            </div>
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          </>
                        </Colxx>
                      </Row>
                    </Colxx>
                  </Row>
                </div>
              </div>
            </div>
          </Card>
        </Colxx>{" "}
      </>
    );
  });

  const positionSuggestions = (
    mentionsClientRect,
    { caretClientRect, left, top }
  ) => {
    const { height: mentionHeight } = mentionsClientRect;
    const { height: caretHeight, width: caretWidth } = caretClientRect;
    return {
      top: top - mentionHeight - caretHeight,
      left: left + caretWidth / 2,
    };
  };
  function openNotes() {
    setIsOpen((isOpen) => !isOpen);
  }

  const showName = (name) => {
    if (!isNullOrEmpty(name)) {
      if (name.includes("null")) {
        let Arr = [];
        Arr = name.split(" ");
        delete Arr[1];
        return Arr[0];
      }
    }

    return name;
  };

  const displayStatus = () => {
    return (
      <>
        {(() => {
          if (!isNullOrEmpty(applicantStatus)) {
            if (applicantStatus !== "APPLIED") {
              return (
                <>
                  {" | "}
                  <strong>{statusValue}:</strong>{" "}
                  <span title={showLocalDateTime(modifiedOn)}>
                    {displayDays(modifiedDays)}
                  </span>{" "}
                </>
              );
            }
          }
        })()}
      </>
    );
  };

  const displayAppliedDays = () => {
    return (
      <>
        {(() => {
          if (!isNullOrEmpty(applicantStatus)) {
            return (
              <>
                <strong>Applied:</strong>{" "}
                <span title={showLocalDateTime(applieddOn)}>
                  {displayDays(appliedDays)}
                </span>
              </>
            );
          }
        })()}
      </>
    );
  };

  const displayDays = (appliedDays) => {
    return (
      <>
        {(() => {
          if (appliedDays == 0) {
            return <>Today</>;
          } else if (appliedDays == 1) {
            return <>1 day</>;
          } else {
            return <>{appliedDays} days</>;
          }
        })()}
      </>
    );
  };

  return (
    <>
      <script
        src="https://cdn.jsdelivr.net/npm/react/umd/react.production.min.js"
        crossOrigin="true"
      ></script>
      <script
        src="https://cdn.jsdelivr.net/npm/react-dom/umd/react-dom.production.min.js"
        crossOrigin="true"
      ></script>
      <script
        src="https://cdn.jsdelivr.net/npm/react-bootstrap@next/dist/react-bootstrap.min.js"
        crossOrigin="true"
      ></script>

      <div>
        <div>
          <div className="skill-header">
            <div>
              <Colxx
                className="mt-2 t-text-[13px]"
                sm={12}
                style={{ padding: 0 }}
              >
                <h3 className="mt-2">
                  <b>{jobId}</b>
                  {jobTitle ? <>| {jobTitle}</> : <></>}
                </h3>
              </Colxx>
            </div>
            <div className="text-right col-lg-6">
              <div className="btn-group">
                <h3 className="mt-2">
                  {displayAppliedDays()}
                  {displayStatus()}
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div>
          <Form>
            <div>
              <div className="skill-header">
                <div>
                  <div className="profile-card-title">
                    <label className="card-title">
                      <h2>Smart Resume Review</h2>
                    </label>
                  </div>
                </div>
                <div className="text-right col-lg-6">
                  <div className="btn-group">
                    <Button
                      color="primary"
                      size="sm"
                      outline
                      onClick={getProxyLoginDetails}
                    >
                      Edit Profile
                    </Button>
                    <Button
                      color="primary"
                      size="sm"
                      outline
                      onClick={copyLPUrl}
                    >
                      {" "}
                      LP Link{" "}
                    </Button>
                    <Button
                      color="primary"
                      size="sm"
                      outline
                      onClick={navigateTo}
                    >
                      Back
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <hr></hr>
            <Row id="smartresume">
              <ComponentToPrint ref={componentRef} />
              <Colxx xxs="12" xl="3" id="rightdiv" className="col-right">
                <>
                  <div>
                    <Card className="mb-2 mt-2 ml-1 mr-1 t-rounded-xl">
                      <div className="ml-4 mt-3 mr-4">
                        <h6>
                          <b>{statusValue}</b>
                        </h6>
                        {showAdditionalReasonsMessage(status)}
                      </div>
                    </Card>
                    <Card className="mb-2 mt-2 ml-1 mr-1 t-rounded-xl">
                      <CardBody>
                        <h5>
                          <b>Next Step</b>
                        </h5>
                        <p>
                          Fanstatic! You may finalize a job offer with the
                          candidate using the contact information on the smart
                          resume. we will also let them know
                        </p>
                      </CardBody>
                    </Card>

                    {taActionRequired == true && (
                      <>
                        {show && (
                          <Card className="mb-2 mt-2 ml-1 mr-1 t-rounded-xl">
                            <CardBody>
                              <h5>
                                <b> Client Question / Comment</b>
                              </h5>

                              <p>{clientComment}</p>
                              <p>{clientQuestion}</p>

                              <Button
                                className=""
                                color="primary"
                                outline
                                onClick={updateTAActed}
                              >
                                Review
                              </Button>
                            </CardBody>
                          </Card>
                        )}
                      </>
                    )}

                    <Card className="mb-2 mt-2 ml-1 mr-1 t-rounded-xl">
                      <CardBody>
                        <h4>
                          <b>Credibility issues</b>
                        </h4>
                        <p>{credibilityReason}</p>
                      </CardBody>
                    </Card>
                    <Card className="mb-2 ml-1  mr-1 t-rounded-xl">
                      <div className="p-3">
                        <MentionsInput
                          id="notes"
                          type="notes"
                          name="notes"
                          maxLength="255"
                          placeholder={"Enter notes..."}
                          onChange={handleChange}
                          style={mentionsInputStyles}
                          value={notesAdded}
                        >
                          <Mention
                            className="t-user-menstion"
                            displayTransform={(id, display) => `@${display}`}
                            trigger="@"
                            style={mentionStyle}
                            data={userMentions}
                            positionSuggestions={(mentions, trigger) => {
                              return {
                                left: 0,
                                top: 0,
                                display: mentions.length > 0 ? "block" : "none",
                              };
                            }}
                          />
                        </MentionsInput>
                      </div>
                      <div className="p-3">
                        <Row>
                          <Col sm={3}>
                            {" "}
                            <Button
                              color="primary"
                              size="sm"
                              outline
                              onClick={addTaNotes}
                            >
                              Add
                            </Button>
                          </Col>
                          <Col sm={9}>
                          <a
                              color="primary"
                              size="sm"
                              outline="true"
                              className="flex t-justify-content-end t-cursor-pointer"
                              onClick={openNotes}
                            >
                              {" "}
                              <u>
                                {!isOpen
                                  ? "View all candidate notes"
                                  : "Back to notes"}
                              </u>
                            </a>
                          </Col>
                        </Row>
                      </div>
                      {isOpen && (
                        <div className="t-notes_scroll ">
                        <Card className="t-toggle-z-index-review ">
                          <div className="p-3">
                            {notesHistory.length > 0 &&
                              notesHistory.map((note, index) => {
                                return (
                                  <div key={index}>
                                   
                                      <div>
                                        <div className=" mt-1">
                                          <Row>
                                            <div className="col-8 t-notes-padding">
                                              {" "}
                                              <div>
                                                <div className="profile-card-title">
                                                  <label>
                                                    <strong>
                                                      <h2>
                                                        {showName(
                                                          note.commentedByName
                                                        )}
                                                      </h2>
                                                    </strong>
                                                    <label>
                                                      {showLocalDateTime(
                                                        note.createdOn
                                                      )}
                                                    </label>
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col"></div>
                                          </Row>
                                        </div>
                                      </div>
                                      <Linkify
                                        className="t-parsed-text"
                                        options={{
                                          defaultProtocol: "https",
                                        }}
                                      >
                                        {note.notes}
                                      </Linkify>
                                      <br />
                                      <div className="mt-2 t-font-size-notification">
                                        {/* <Row sm={4} className="t-font-size-notification"> */}
                                            <i>{note.jobId}</i>{" "}<b>|</b>{" "}
                                            <i>{note.jobTitle}</i>
                                         
                                        {/* </Row> */}
                                      </div>
                                   

                                    <hr />
                                  </div>
                                );
                              })}
                          </div>
                        </Card></div>
                      )}
                      {!isOpen && (
                        <Accordion className="">
                          <div className="border border-bottom-0">
                            <Accordion.Item eventKey="0" aria-expanded="false">
                              <Accordion.Header className="search-accordion-header "></Accordion.Header>
                              <Accordion.Body>
                                {taNotes.length > 0 &&
                                  taNotes.map((note, index) => {
                                    return (
                                      <div key={index}>
                                        <div>
                                          <div className=" mt-1">
                                            <Row>
                                              <div className="col-8 t-notes-padding">
                                                {" "}
                                                <div>
                                                  <div className="profile-card-title">
                                                    <label>
                                                      <strong>
                                                        <h2>
                                                          {showName(
                                                            note.commentedByName
                                                          )}
                                                        </h2>
                                                      </strong>
                                                      <label>
                                                        {showLocalDateTime(
                                                          note.createdOn
                                                        )}
                                                      </label>
                                                    </label>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="col t-cursor-pointer">
                                                {showDeleteIcon(
                                                  note.autoGenerated,
                                                  index,
                                                  note.id,
                                                  note.commentedById,
                                                  note
                                                )}
                                              </div>
                                            </Row>
                                          </div>
                                        </div>
                                        <Linkify
                                          className="t-parsed-text"
                                          options={{ defaultProtocol: "https" }}
                                        >
                                          {note.notes}
                                        </Linkify>{" "}
                                        <hr />
                                      </div>
                                    );
                                  })}
                              </Accordion.Body>
                            </Accordion.Item>
                          </div>
                        </Accordion>
                      )}
                    </Card>

                    <Card className="mb-2 mt-2 ml-1 mr-1 t-rounded-xl">
                      <div>
                        <Colxx>
                          <div className="">
                            <Row className="p-3">
                              <Input
                                id=""
                                type="select"
                                name="publicTitle"
                                onChange={(e) => handleStatusChange(e)}
                                value={applicantStatus}
                                className="form-control"
                                disabled={checked}
                              >
                                {checked == false && (
                                  <option value={""}>{"Select status"}</option>
                                )}
                                {jobApplicantTypes.map((status) => (
                                  <option key={status.key} value={status.key}>
                                    {status.value}
                                  </option>
                                ))}{" "}
                              </Input>
                            </Row>
                            {shortlisted === true ? (
                              <Row className="p-3">
                                <Colxx sm={12} className="p-0">
                                  <div className="tacbox">
                                    <label>
                                      <input
                                        data-testid="relevantJobExp"
                                        type="checkbox"
                                        className="inputterm"
                                        checked={relevantJobExp}
                                        disabled={checked}
                                        onChange={(e) =>
                                          setRelevantJobExp(e.target.checked)
                                        }
                                      />
                                      <span className="checkboxlabel">
                                        Relevant job experiences
                                      </span>
                                    </label>
                                  </div>
                                  <div className="tacbox">
                                    <label>
                                      <input
                                        data-testid="relevantEdu"
                                        type="checkbox"
                                        className="inputterm"
                                        checked={relevantEdu}
                                        disabled={checked}
                                        onChange={(e) =>
                                          setRelevantEdu(e.target.checked)
                                        }
                                      />
                                      <span className="checkboxlabel">
                                        Relevant education
                                      </span>
                                    </label>
                                  </div>
                                  <div className="tacbox">
                                    <label>
                                      <input
                                        data-testid="strongSkillFit"
                                        type="checkbox"
                                        className="inputterm"
                                        checked={strongSkillFit}
                                        disabled={checked}
                                        onChange={(e) =>
                                          setStrongSkillFit(e.target.checked)
                                        }
                                      />
                                      <span className="checkboxlabel">
                                        Strong skill fit
                                      </span>
                                    </label>
                                  </div>
                                  <div className="tacbox">
                                    <label>
                                      <input
                                        data-testid="relevantLanguages"
                                        type="checkbox"
                                        className="inputterm"
                                        checked={relevantLanguages}
                                        disabled={checked}
                                        onChange={(e) =>
                                          setRelevantLanguages(e.target.checked)
                                        }
                                      />
                                      <span className="checkboxlabel">
                                        Relevant languages
                                      </span>
                                    </label>
                                  </div>
                                  <div className="tacbox">
                                    <label>
                                      <input
                                        data-testid="grtSoftSkillFit"
                                        type="checkbox"
                                        className="inputterm"
                                        checked={grtSoftSkillFit}
                                        disabled={checked}
                                        onChange={(e) =>
                                          setGrtSoftSkillFit(e.target.checked)
                                        }
                                      />
                                      <span className="checkboxlabel">
                                        Great soft skill fit
                                      </span>
                                    </label>
                                  </div>
                                  <div className="tacbox">
                                    <label>
                                      <input
                                        data-testid="askCandidateQuestions"
                                        type="checkbox"
                                        className="inputterm"
                                        checked={askCandidateQuestions}
                                        disabled={checked}
                                        onChange={(e) =>
                                          setAskCandidateQuestions(
                                            e.target.checked
                                          )
                                        }
                                      />
                                      <span className="checkboxlabel">
                                        I just want to ask the candidate some
                                        questions
                                      </span>
                                    </label>
                                  </div>
                                </Colxx>
                              </Row>
                            ) : (
                              <></>
                            )}
                            {interviewScheduled === true ||
                            interviewRequested === true ||
                            interviewCompleted === true ? (
                              <Row className="p-3">
                                <Label className="mt-2">Interview Type</Label>
                                <Input
                                  type="select"
                                  value={interviewType}
                                  disabled={checked}
                                  onChange={(e) => handleInterviewTypeChange(e)}
                                >
                                  {jobInterviewTypes.map(({ value, key }) => (
                                    <option key={key} value={key}>
                                      {value}
                                    </option>
                                  ))}
                                </Input>
                              </Row>
                            ) : (
                              <></>
                            )}

                            {Tareject === true && (
                              <Row className="tareject">
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="jobTenure"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={jobTenure}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setJobTenure(e.target.checked)
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      Job Tenure {"    "}
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="salaryExpectations"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={salaryExpectations}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setSalaryExpectations(e.target.checked)
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      {""}Salary Expectations
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="insuffOrIrrelevantExp"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={insuffOrIrrelevantExp}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setInsuffOrIrrelevantExp(
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      Insufficient Or Irrelevant Experience
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="insuffOrIrrelevantEdu"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={insuffOrIrrelevantEdu}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setInsuffOrIrrelevantEdu(
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      Insufficient Or Irrelevant Education
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="missingLicencesOrCerts"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={missingLicencesOrCerts}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setMissingLicencesOrCerts(
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      Missing Licenses Or Certifications
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="selectedAnotherCandidate"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={selectedAnotherCandidate}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setSelectedAnotherCandidate(
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      Selected Another Candidate
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="prevRejectedCandidate"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={prevRejectedCandidate}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setPrevRejectedCandidate(
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      Previously Rejected Candidate
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="poorIntrview"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={poorInterview}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setPoorInterview(e.target.checked)
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      Poor Interview
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="noShow"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={noShow}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setNoShow(e.target.checked)
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      No Show
                                    </span>
                                  </label>
                                </div>
                                <div className="tacbox col-12">
                                  <label>
                                    <input
                                      data-testid="hiringOfferDeclined"
                                      type="checkbox"
                                      className="inputterm"
                                      checked={hiringOfferDeclined}
                                      disabled={checked}
                                      onChange={(e) =>
                                        setHiringOfferDeclined(e.target.checked)
                                      }
                                    />
                                    <span className="checkboxlabel">
                                      Hiring Offer Declined
                                    </span>
                                  </label>
                                </div>
                              </Row>
                            )}

                            <Row className=" p-3">
                              <textarea
                                id="adlreasons"
                                type="text"
                                name="Additional Reasons"
                                data-testid="account-area"
                                placeholder={"Additional Reasons"}
                                onChange={(e) =>
                                  setAdditionalReasons(e.target.value)
                                }
                                value={additionalReasons}
                                disabled={checked}
                                className="is-touched is-pristine av-invalid is-invalid form-control"
                              ></textarea>
                            </Row>
                          </div>
                        </Colxx>
                      </div>
                    </Card>
                  </div>

                  <div className="ml-2 mt-4">
                    {jobReqStatus != "CLOSED" ? (
                      <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={changeApplicantJobStatus}
                      >
                        Save
                      </Button>
                    ) : (
                      <Button
                        disabled
                        color="primary"
                        size="sm"
                        outline
                        onClick={changeApplicantJobStatus}
                      >
                        Save
                      </Button>
                    )}
                    <Button
                      className="ml-3"
                      color="primary"
                      size="sm"
                      outline
                      onClick={navigateTo}
                    >
                      Back
                    </Button>
                  </div>
                </>
              </Colxx>
            </Row>
          </Form>
        </div>
      </div>
      <Modal isOpen={modalcopy} toggle={() => setModalcopy(!modalcopy)}>
        <ModalBody>
          Do you want to <strong>delete this notes</strong>
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalcopy(false)}
          >
            No
          </Button>
          <Button color="primary" size="sm" outline onClick={deleteTaNotes}>
            Yes
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        className="mt-5"
        isOpen={modalBasic}
        toggle={() => setModalBasic(!modalBasic)}
      >
        <ModalHeader className="p-3">
          <strong>Update Notes</strong>
        </ModalHeader>
        <ModalBody>
          <MentionsInput
            id="notes"
            type="notes"
            name="notes"
            maxLength="255"
            placeholder={"Enter notes..."}
            onChange={updatedHandleChange}
            style={mentionsInputStyles}
            value={taSelectedNotes}
          >
            <Mention
              className="t-user-menstion"
              displayTransform={(id, display) => `@${display}`}
              trigger="@"
              // onAdd={setNotificationuser}
              // onRemove={handleRemove}
              style={mentionStyle}
              data={userMentions}
              positionSuggestions={positionSuggestions}
            />
          </MentionsInput>
        </ModalBody>
        <ModalFooter className="p-3">
          <Button
            className="m-0"
            color="primary"
            size="sm"
            outline
            onClick={updateTaNotes}
          >
            Update Notes
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ViewCandidateDetails;
